<template>
    <div class="home">
        <div class="top">
            <TableBar class="tab-bar-content"></TableBar>

            <div class="top-contain">
                <!--                <div class="top-contain-people"></div>-->
                <!--                <div class="top-contain-list">-->
                <!--                    <div class="list-title">为用户提供全面的互联网教育信息</div>-->
                <!--                    <div class="list">-->
                <!--                        <div class="list-item" v-for="items in introList" :key="items">-->
                <!--                            <div class="icon"></div>-->
                <!--                            {{items}}-->
                <!--                        </div>-->
                <!--                    </div>-->
                <!--                </div>-->

            </div>

        </div>
        <div class="down">
            <router-view v-show="!index"/>
            <home v-show="index"></home>
            <p class="biaozhu">公司地址：北京市朝阳区融科望京中心 A 座 18 层 1808</p>
            <p class="biaozhu2">版权所有：北京红松在线科技有限公司 京ICP备2020042506号-1 Copyright  2020 www.hongsong.club All Rights Reserved</p>

            <div style="width:300px;margin:0 auto; padding:20px 0;">
                <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502041554"
                   style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
                    <img src="https://images-1300484082.cos.ap-chengdu.myqcloud.com/micro/hy/police.png"
                         style="float:left;"/>
                    <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">京公网安备
                        11010502041554号</p>
                </a>
            </div>
        </div>

    </div>
</template>

<script>
    import TableBar from "../components/TableBar";
    import home from "../components/Home"

    export default {
        name: 'Home',
        components: {
            TableBar, home
        },
        watch: {
            $route: {
                handler: function () {
                    if (this.$route.name === 'Index') {

                        this.index = true
                    } else {
                        this.index = false
                    }

                },
                // 深度观察监听
                deep: true
            }
        },
        mounted() {
            console.log(this.barList)
        },
        data() {
            return {
                index: true,
                introList: ['一部手机学课程', '名师大咖天天有', '活动福利领不停', '精品课程随心看']
            };
        }
    }
</script>

<style scoped lang="scss">
    .tab-bar-content {
        position: absolute;
        top: -68.5px;
    }

    .home {
        width: 100%;
        height: 100%;
        position: relative;

    }

    .top {
        margin-top: 68.5px;
        width: 100%;
        height: 384px;
        background-image: url("../assets/img/earthBg2.png");
        background-repeat: no-repeat;
        background-position: right bottom;
        background-size: cover;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;

        .top-contain {
            width: 100%;
            flex: 1;
            display: flex;
            justify-content: space-between;

            padding: 36.5px 165px 0 63px;

            .top-contain-people {
                width: 50%;
                max-width: 371px;
                height: 222px;
                background: url("../assets/img/home-people.png") right center/contain no-repeat;
            }

            .top-contain-list {

                width: 450px;
                display: flex;
                flex-direction: column;
                justify-content: center;

                .list-title {
                    font-size: 21px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: rgba(51, 51, 51, 1);
                    display: flex;
                    align-items: center;
                    padding-bottom: 18px;
                }

                .list {
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;

                    .list-item {
                        font-size: 16px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: rgba(51, 51, 51, 1);
                        letter-spacing: 1px;
                        display: flex;
                        align-items: center;
                        margin: 5px 0;

                        .icon {
                            width: 25px;
                            height: 15px;
                            margin-right: 7px;
                            background: url("../assets/img/icon-list.png") center/contain no-repeat;

                        }
                    }

                }
            }
        }
    }

    .down {
        /*position: absolute;*/
        /*left: 0;*/
        /*bottom: 0;*/
        /*width: 100%;*/
        /*height: 40%;*/
        padding-top: 10px;
    }

    .biaozhu {
        width: 100%;
        font-size: 8px;
        color: rgb(187, 187, 187);
        text-align: center;
        margin-top: 30px;
        margin-bottom: 10px;
    }

    .biaozhu2 {
        width: 100%;
        font-size: 8px;
        color: rgb(187, 187, 187);
        text-align: center;
        margin-top: 10px;
        margin-bottom: 10px;
    }
</style>
